import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { HeaderComponent } from './shared/header/header.component';
import { SideNavigationMenuComponent } from './shared/side-navigation-menu/side-navigation-menu.component';
import { LandingComponent } from './landing/landing/landing.component';
import { LayoutsComponent } from './shared/layouts/layouts.component';

import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { OAuthModule } from 'angular-oauth2-oidc';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './services/auth.interceptor';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { LicenseComponent } from './pages/license/license.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSidenavModule } from '@angular/material/sidenav';
import { HelpDialogComponent } from './pages/help-dialog/help-dialog.component';
import { ConfirmDialogComponent } from './pages/confirm-dialog/confirm-dialog.component';
import { AcknowledgeDialogComponent } from './pages/acknowledge-dialog/acknowledge-dialog.component';
import { LandingHeaderComponent } from './landing/landing-header/landing-header.component';
import { LandingFooterComponent } from './landing/landing-footer/landing-footer.component';
import { LandingAboutUsComponent } from './landing/landing-about-us/landing-about-us.component';
import { LandingLayoutsComponent } from './landing/landing-layouts/landing-layouts.component';
import { LandingContactUsComponent } from './landing/landing-contact-us/landing-contact-us.component';
import { LandingRefundPolicyComponent } from './landing/landing-refund-policy/landing-refund-policy.component';
import { LandingTermsConditionsComponent } from './landing/landing-terms-conditions/landing-terms-conditions.component';
import { LandingSecurityPrivacyComponent } from './landing/landing-security-privacy/landing-security-privacy.component';
import { LandingDataProcessingComponent } from './landing/landing-data-processing/landing-data-processing.component';
import { LandingDisclaimerComponent } from './landing/landing-disclaimer/landing-disclaimer.component';
import { LandingCopyrightComponent } from './landing/landing-copyright/landing-copyright.component';
import { LandingNtripCasterComponent } from './landing/landing-ntrip-caster/landing-ntrip-caster.component';
import { LandingPpkDownloaderComponent } from './landing/landing-ppk-downloader/landing-ppk-downloader.component';
import { LandingRtkBaseAnalyzerComponent } from './landing/landing-rtk-base-analyzer/landing-rtk-base-analyzer.component';
import { LandingWhatsNewComponent } from './landing/landing-whats-new/landing-whats-new.component';
import { LandingQuickStartComponent } from './landing/landing-quick-start/landing-quick-start.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ExternalMountpointConnectionsComponent } from './pages/external-mountpoint-connections/external-mountpoint-connections.component';
import { AddMpcDialogComponent } from './pages/external-mountpoint-connections/add-mpc-dialog.component';
import { PpkDownloaderProComponent } from './pages/ppk-downloader-pro/ppk-downloader-pro.component';
import { RtkBaseAnalyzerProComponent } from './pages/rtk-base-analyzer-pro/rtk-base-analyzer-pro.component';
import { PpkStudioComponent } from './pages/ppk-studio/ppk-studio.component';
import { PpkPlotComponent } from './pages/ppk-plot/ppk-plot.component';
import { SelectDownloaderFileDialogComponent } from './pages/ppk-studio/select-downloader-file-dialog/select-downloader-file-dialog.component';
import { FooterComponent } from './shared/footer/footer.component';
import { MountpointConnectionSetupDialogComponent } from './pages/mountpoint-connection-setup-dialog/mountpoint-connection-setup-dialog.component';
import { PpkStudioHelpDialogComponent } from './pages/ppk-studio/ppk-studio-help-dialog/ppk-studio-help-dialog.component';
import { PpkDownloaderHelpDialogComponent } from './pages/ppk-downloader-pro/ppk-downloader-help-dialog/ppk-downloader-help-dialog.component';
import { RtkBaseAnalyzerHelpDialogComponent } from './pages/rtk-base-analyzer-pro/rtk-base-analyzer-help-dialog/rtk-base-analyzer-help-dialog.component';
import { PpkDownloaderStartTimeHelpDialogComponent } from './pages/ppk-downloader-pro/ppk-downloader-start-time-help-dialog/ppk-downloader-start-time-help-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    HeaderComponent,
    SideNavigationMenuComponent,
    LandingComponent,
    LayoutsComponent,
    UserProfileComponent,
    HelpDialogComponent,
    ConfirmDialogComponent,
    AcknowledgeDialogComponent,
    LandingHeaderComponent,
    LandingFooterComponent,
    LandingAboutUsComponent,
    LandingLayoutsComponent,
    LandingContactUsComponent,
    LandingRefundPolicyComponent,
    LandingTermsConditionsComponent,
    LandingSecurityPrivacyComponent,
    LandingDataProcessingComponent,
    LandingDisclaimerComponent,
    LandingCopyrightComponent,
    LandingNtripCasterComponent,
    LandingPpkDownloaderComponent,
    LandingRtkBaseAnalyzerComponent,
    LandingWhatsNewComponent,
    LandingQuickStartComponent,
    LicenseComponent,
    ExternalMountpointConnectionsComponent,
    AddMpcDialogComponent,
    PpkDownloaderProComponent,
    RtkBaseAnalyzerProComponent,
    PpkStudioComponent,
    PpkPlotComponent,
    SelectDownloaderFileDialogComponent,
    PpkStudioHelpDialogComponent,
    PpkDownloaderHelpDialogComponent,
    RtkBaseAnalyzerHelpDialogComponent,
    PpkDownloaderStartTimeHelpDialogComponent,
    MountpointConnectionSetupDialogComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    OAuthModule.forRoot(),
    FormsModule,
    MatTooltipModule,
    MatDialogModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSidenavModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
